import { renderListingImage } from '../../listing_tile_rendering/listingImageRenderer'
import { renderListingPrice } from '../../listing_tile_rendering/listingPriceRenderer'
import renderWishlistButton from '../../listing_tile_rendering/wishlistButtonRenderer'
import { getWishlistedItemsFromPage, hrefFromHit } from '../../listing_tile_rendering/listingTileUtils'
import { t, isTradeBuyer } from './config'
import { escapeHTML, renderRichText, safeHref } from './richText'
import { feedbackHTML } from './feedback'
import chevronIcon from '../../../images/icons/tiny-right-chevron.svg'

// Unknown kinds are dropped in silence so the backend can ship a widget type ahead of us.
// renderFeedback gives a tile the chat's verdict for its listing.
export function widgetHTML (widget, renderFeedback) {
  switch (widget.kind) {
    case 'results': return resultsWidgetHTML(widget, renderFeedback)
    case 'actions': return actionsWidgetHTML(widget)
    default: return ''
  }
}

// An empty carousel is not rendered: the reply that follows explains there were no matches.
export function resultsWidgetHTML ({ widgetId, payload }, renderFeedback = feedbackHTML) {
  const listings = payload.listings || []
  if (listings.length === 0) return ''

  const wishlisted = getWishlistedItemsFromPage()
  const tiles = listings.map(hit => resultTile(hit, wishlisted, renderFeedback)).join('')

  return `
    <div class="vsd-vera-turn vsd-vera-turn--assistant" data-widget-id="${escapeHTML(widgetId)}">
      <span class="vsd-vera-turn__label">${t('assistant')}</span>
      ${payload.rationale ? `<p class="vsd-vera-turn__text">${renderRichText(payload.rationale)}</p>` : ''}
      <div class="vsd-vera-carousel vjs-vera-carousel" data-result-set-id="${escapeHTML(payload.result_set_id)}">
        <div class="vsd-vera-carousel__track vjs-vera-carousel-track" role="group" aria-label="${escapeHTML(payload.title || '')}">
          ${tiles}
        </div>
        ${carouselControlsHTML()}
      </div>
    </div>
  `
}

export function actionsWidgetHTML ({ widgetId, payload }) {
  return `
    <div class="vsd-vera-actions vjs-vera-actions" data-widget-id="${escapeHTML(widgetId)}" data-result-set-id="${escapeHTML(payload.result_set_id || '')}">
      <p class="vsd-vera-turn__text vsd-vera-actions__intro">${t('actions.intro')}</p>
      ${(payload.actions || []).map(actionHTML).join('')}
    </div>
  `
}

export function bindCarousels (container) {
  container.addEventListener('click', event => {
    const arrow = event.target.closest('.vjs-vera-carousel-prev, .vjs-vera-carousel-next')
    if (!arrow) return

    const track = arrow.closest('.vjs-vera-carousel').querySelector('.vjs-vera-carousel-track')
    const step = track.querySelector('.vjs-vera-result')?.offsetWidth || track.clientWidth
    const direction = arrow.classList.contains('vjs-vera-carousel-next') ? 1 : -1
    track.scrollBy({ left: step * direction, behavior: 'smooth' })
  })
}

function resultTile (hit, wishlisted, renderFeedback) {
  const href = escapeHTML(hrefFromHit(hit))
  const wishlistItem = wishlisted.find(item => item.listingID === parseInt(hit.objectID))
  const isLoggedIn = document.body.dataset.loggedIn === 'true'

  return `
    <article class="vsd-listing__container vsd-vera-result vjs-vera-result vjs-results-product-click" data-productid="${escapeHTML(hit.objectID)}" data-position="${escapeHTML(hit.__position)}">
      ${renderWishlistButton(hit.objectID, wishlistItem?.wishlistID, isLoggedIn, 'within-image')}
      <a class="vsd-listing__image-container vsd-listing__image-container-2025-redesign content-center border-none" href="${href}" target="_blank" rel="noopener">
        ${renderListingImage(hit, true)}
      </a>
      <a class="vsd-vera-result__title vjs-vera-result-title" href="${href}" target="_blank" rel="noopener">${escapeHTML(hit.title)}</a>
      <div class="vsd-vera-result__price">${renderListingPrice(hit, isTradeBuyer(), true)}</div>
      ${renderFeedback(hit.objectID)}
    </article>
  `
}

function carouselControlsHTML () {
  return `
    <button type="button" class="vsd-vera-carousel__arrow vsd-vera-carousel__arrow--prev vjs-vera-carousel-prev" aria-label="${t('results.previous')}">
      <img src="${chevronIcon}" alt="">
    </button>
    <button type="button" class="vsd-vera-carousel__arrow vsd-vera-carousel__arrow--next vjs-vera-carousel-next" aria-label="${t('results.next')}">
      <img src="${chevronIcon}" alt="">
    </button>
  `
}

// An action with an href opens in a new tab; one without is handled by the chat.
function actionHTML (action) {
  const classes = `vjs-vera-action ${action.style === 'primary' ? 'vsd-button__filled' : 'vsd-button__outlined'} vsd-button__small`
  const href = safeHref(action.href)
  return href
    ? `<a class="${classes}" href="${escapeHTML(href)}" target="_blank" rel="noopener" data-action-id="${escapeHTML(action.id)}">${escapeHTML(action.label)}</a>`
    : `<button type="button" class="${classes}" data-action-id="${escapeHTML(action.id)}">${escapeHTML(action.label)}</button>`
}
